import dynamic from 'next/dynamic';

import { HeroProps } from './HeroBanner.types';

export const HeroBannerMGP = dynamic<HeroProps>(() => import('./HeroBanner'));
